import {
  Box,
  Button,
  Checkbox,
  Flex,
  Grid,
  Loader,
  LoadingOverlay,
  TextInput,
  Title,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { IconCheck } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { repositoryPos } from "../../../../_base/_const/_constVar";
import { MessageResponse } from "../../../../model/MessageResponse";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";

interface TblDmItemNotesModel {
  id: number;
  code: string | null;
  name: string | null;
  status: string;
  createdDate: string | null;
  createdBy: number | null;
  lastUpdatedDate: string | null;
  lastUpdatedBy: number | null;
}

const CreateAndEditItemNotes = ({
  data,
  onSuccess,
}: {
  data?: TblDmItemNotesModel;
  onSuccess: any;
}) => {
  const [visible, { toggle, open, close }] = useDisclosure(false);

  const form = useForm<TblDmItemNotesModel>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      id: 0,
      name: null,
      code: null,
      status: "Y",
      createdDate: null,
      createdBy: null,
      lastUpdatedDate: null,
      lastUpdatedBy: null,
    },

    validate: {
      code: (value: string | null) => {
        if (!value || value.length < 2) {
          return "Mã phải có ít nhất 3 kí tự !";
        }
      },
      name: (value: string | null) => {
        if (!value || value.length < 2) {
          return "Ghi chú hàng hóa phải có ít nhất 3 kí tự !";
        }
      },
    },
  });

  const handleCreateItemNotes = async (dataSubmit: TblDmItemNotesModel) => {
    open();
    try {
      const res = await repositoryPos.post<MessageResponse<any>>(
        "/api/v1/TblDmItemNote/create",
        dataSubmit,
      );

      if (res && res.success) {
        NotificationExtension.Success("Tạo mới ghi chú hàng hóa thành công !");
        setTimeout(() => {
          modals.closeAll();
          onSuccess();
        }, 1000);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  const handleEditItemNotes = async (dataSubmit: TblDmItemNotesModel) => {
    open();
    try {
      const res = await repositoryPos.post<MessageResponse<any>>(
        "/api/v1/TblDmItemNote/edit",
        dataSubmit,
      );

      if (res && res.success) {
        NotificationExtension.Success("Cập nhật ghi chú hàng hóa thành công !");
        setTimeout(() => {
          modals.closeAll();
          onSuccess();
        }, 1000);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  useEffect(() => {
    if (data) {
      form.setValues(data);
    }
  }, [data]);

  return (
    <Box
      component="form"
      maw={600}
      w={"30vw"}
      onSubmit={form.onSubmit((e: TblDmItemNotesModel) => {
        if (data) {
          handleEditItemNotes(e);
        } else {
          handleCreateItemNotes(e);
        }
      })}
    >
      <LoadingOverlay
        visible={visible}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 5 }}
        loaderProps={{
          children: (
            <Flex direction={"column"} align="center" gap="xs">
              <Loader type="dots" size={35}></Loader>
              {/* <Title size={15}> Đang upload tài liệu...</Title> */}
              <Title size={12}>
                {" "}
                Hệ thống đang xử lý dữ liệu, vui lòng chờ trong giây lát ...
              </Title>
            </Flex>
          ),
        }}
      />
      <Grid>
        <Grid.Col span={{ base: 12, xs: 3.5 }}>
          <TextInput
            key={form.key("code")}
            label="Mã"
            placeholder="Nhập mã"
            withAsterisk
            {...form.getInputProps("code")}
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, xs: 8.5 }}>
          <TextInput
            key={form.key("name")}
            label="Ghi chú hàng hóa"
            placeholder="Nhập ghi chú hàng hóa"
            withAsterisk
            {...form.getInputProps("name")}
          />
        </Grid.Col>
      </Grid>
      <Flex justify={"space-between"} align={"center"}>
        <Checkbox
          label="Sử dụng"
          checked={form.getValues().status === "Y"}
          onClick={() => {
            form.setValues((prev) => ({
              ...prev,
              status: prev.status === "Y" ? "N" : "Y",
            }));
          }}
        />
        <Button
          type="submit"
          leftSection={<IconCheck size={16} />}
          loading={visible}
          disabled={visible}
        >
          Lưu
        </Button>
      </Flex>
    </Box>
  );
};

export default CreateAndEditItemNotes;
